module.exports = __webpack_public_path__ + "assets/img/background.064ffff8.png";